<mat-card class="cardT">
  <div class="controle-header">
    <span class="controle-header__title">Controle Finança</span>
    <button mat-icon-button class="nav-btn" [disabled]="!idControleFinancaAnterior" type="button" color="primary"
      (click)="onPreviousData()" matTooltip="Mês anterior" aria-label="Mês anterior">
      <mat-icon>chevron_left</mat-icon>
    </button>
    <button mat-icon-button class="nav-btn" [disabled]="!idControleFinancaProximo" type="button" color="primary"
      (click)="onNextData()" matTooltip="Próximo mês" aria-label="Próximo mês">
      <mat-icon>chevron_right</mat-icon>
    </button>
    <ng-container *ngIf="blMesFinalizado !== undefined">
      <button mat-icon-button *ngIf="!blMesFinalizado && (blMesAnteriorFinalizado === true || blMesAnteriorFinalizado === null) && (blMesProximoFinalizado === false || blMesProximoFinalizado === null)" (click)="onEncerrarMes()" matTooltip="Encerrar mês">
        <mat-icon style="color: #4caf50;">lock_open</mat-icon>
      </button>
      <button mat-icon-button *ngIf="blMesFinalizado && (blMesProximoFinalizado === false || blMesProximoFinalizado === null) && (blMesAnteriorFinalizado === true || blMesAnteriorFinalizado === null)" (click)="onReabrirMes()" matTooltip="Reabrir mês">
        <mat-icon style="color: #d4a373;">lock</mat-icon>
      </button>
      <button mat-icon-button type="button" disabled *ngIf="blMesFinalizado && !((blMesProximoFinalizado === false || blMesProximoFinalizado === null) && (blMesAnteriorFinalizado === true || blMesAnteriorFinalizado === null))" matTooltip="Mês encerrado" aria-label="Mês encerrado">
        <mat-icon style="color: #9e9e9e;">lock</mat-icon>
      </button>
      <button mat-icon-button type="button" disabled *ngIf="!blMesFinalizado && !((blMesAnteriorFinalizado === true || blMesAnteriorFinalizado === null) && (blMesProximoFinalizado === false || blMesProximoFinalizado === null))" matTooltip="Mês aberto" aria-label="Mês aberto">
        <mat-icon style="color: #9e9e9e;">lock_open</mat-icon>
      </button>
    </ng-container>
  </div>
</mat-card>
<mat-card class="resumo-card">
  <div class="resumo-card__header">
    <div class="resumo-card__header-left">
      <mat-icon class="resumo-card__icon">event</mat-icon>
      <span class="resumo-card__title">{{ getFormattedDate() | titlecase }}</span>
      <mat-icon *ngIf="blMesFinalizado" class="finalizado-icon" matTooltip="Mês finalizado">check_circle</mat-icon>
    </div>
  </div>

  <div class="resumo-grid">
    <ng-container *ngFor="let cofx of listaControleFinancaXMovimento">
      <div class="resumo-item" [ngStyle]="{ '--accent': getResumoAccent(cofx) }">
        <div class="resumo-item__top">
          <div class="resumo-item__label">{{ cofx.noTipoMovimento }} {{cofx.vlSaldo ? ' - ' + formatBRL(cofx.vlSaldo) : ''}} </div>
          <div class="resumo-item__icons">
            <mat-icon *ngIf="isCofxTotalmentePago(cofx.idControleFinancaXMovimento)" class="paid-check"
              matTooltip="100% pago">check_circle</mat-icon>
            <mat-icon class="resumo-item__icon" [style.color]="getIconColor(cofx).color || null">{{
              getIconColor(cofx).icon
              }}</mat-icon>
          </div>
        </div>
        <div class="resumo-item__value">{{ formatBRL(getResumoTotal(cofx.idControleFinancaXMovimento)) }}</div>
        <div class="resumo-item__sub">Pago: {{ formatBRL(getResumoPago(cofx.idControleFinancaXMovimento)) }}</div>
        <div class="resumo-item__sub">Diferença: {{ cofx.vlSaldo ? formatBRL(getResumoDiferencaSaldo(cofx.idControleFinancaXMovimento, cofx.vlSaldo)) : formatBRL(getResumoDiferenca(cofx.idControleFinancaXMovimento)) }}</div>
      </div>
    </ng-container>

    <div *ngIf="listaControleFinancaXMovimentoCartoes.length > 0" class="resumo-item"
      [ngStyle]="{ '--accent': getResumoAccentById(-1) }">
      <div class="resumo-item__top">
        <div class="resumo-item__label">Saída + Cartões</div>
        <div class="resumo-item__icons">
          <mat-icon *ngIf="isCofxTotalmentePago(-1)" class="paid-check" matTooltip="100% pago">check_circle</mat-icon>
          <mat-icon class="resumo-item__icon">{{ getResumoSpecialIcon(-1) }}</mat-icon>
        </div>
      </div>
      <div class="resumo-item__value">{{ formatBRL(getResumoTotal(-1)) }}</div>
      <div class="resumo-item__sub">Pago: {{ formatBRL(getResumoPago(-1)) }}</div>
      <div class="resumo-item__sub">Diferença: {{ formatBRL(getResumoDiferenca(-1)) }}</div>
    </div>

    <div class="resumo-item" [ngStyle]="{ '--accent': getResumoAccentById(0) }">
      <div class="resumo-item__top">
        <div class="resumo-item__label">Saldo</div>
        <div class="resumo-item__icons">
          <mat-icon class="resumo-item__icon">{{ getResumoSpecialIcon(0) }}</mat-icon>
        </div>
      </div>
      <div class="resumo-item__value">{{ formatBRL(getResumoTotal(0)) }}</div>
      <div class="resumo-item__sub">Pago: {{ formatBRL(getResumoPago(0)) }}</div>
      <div class="resumo-item__sub">Diferença: {{ formatBRL(getResumoDiferenca(0)) }}</div>
    </div>

    <div *ngIf="vlSaldoAcumulado !== undefined" class="resumo-item"
      [ngStyle]="{ '--accent': '#00695c' }">
      <div class="resumo-item__top">
        <div class="resumo-item__label">Saldo Acumulado</div>
        <div class="resumo-item__icons">
          <mat-icon class="resumo-item__icon">history</mat-icon>
        </div>
      </div>
      <div class="resumo-item__value">{{ formatBRL(vlSaldoAcumulado) }}</div>
      <div *ngIf="vlAcumuladoMesAnterior !== null && vlAcumuladoMesAnterior !== undefined" class="resumo-item__sub">
        Mês Anterior: {{ formatBRL(vlAcumuladoMesAnterior) }}
      </div>
      <div class="resumo-item__sub">Saldo Atual: {{ formatBRL(vlSaldoAtual) }}</div>
    </div>
  </div>
</mat-card>
<br />
<mat-card class="cardT" style="display: flex; justify-content: left; align-items: center;">
  <span>Movimentos</span>
  <button mat-icon-button class="btn" matTooltip="Adicionar cartão" (click)="onAdicionarCartao()">
    <mat-icon>add_card</mat-icon>
  </button>
</mat-card>
<div class="form-fields">
  <mat-tab-group class="edit-input-field" (selectedIndexChange)="onTabIndexChange($event)">
    <mat-tab>
      <ng-template mat-tab-label> Entrada/Saída </ng-template>
      <div class="entradaSaida-div">
        <mat-card class="movimento-card movimento-card--entrada">
          <div class="movimento-card__header">
            <div class="movimento-card__header-left">
              <mat-icon class="movimento-card__icon">arrow_downward</mat-icon>
              <span class="movimento-card__title">Entrada</span>
            </div>
            <span class="movimento-card__badge" matTooltip="Quantidade de movimentos">
              {{ getMovimentosCountFor(controleFinancaXMovimentoEntrada) }}
            </span>
          </div>
          <div class="movimento-card__body">
            <app-controle-financa-movimentos *ngFor="let cofx of controleFinancaXMovimentoEntrada"
              [controleFinancaXMovimento]="cofx" (isChanged)="onCalcularValorTotal()"
              (countChanged)="onMovimentosCountChanged(cofx.idControleFinancaXMovimento, $event)"></app-controle-financa-movimentos>
          </div>
        </mat-card>

        <mat-card class="movimento-card movimento-card--saida">
          <div class="movimento-card__header">
            <div class="movimento-card__header-left">
              <mat-icon class="movimento-card__icon">arrow_upward</mat-icon>
              <span class="movimento-card__title">Saída</span>
            </div>
            <span class="movimento-card__badge" matTooltip="Quantidade de movimentos">
              {{ getMovimentosCountFor(controleFinancaXMovimentoSaida) }}
            </span>
          </div>
          <div class="movimento-card__body">
            <app-controle-financa-movimentos *ngFor="let cofx of controleFinancaXMovimentoSaida"
              [controleFinancaXMovimento]="cofx" (isChanged)="onCalcularValorTotal()"
              (isCartao)="onDefinirCartao($event)"
              (countChanged)="onMovimentosCountChanged(cofx.idControleFinancaXMovimento, $event)"></app-controle-financa-movimentos>
          </div>
        </mat-card>
      </div>
    </mat-tab>

    <mat-tab *ngIf="listaControleFinancaXMovimentoCartoes.length > 0">
      <ng-template mat-tab-label> Cartões </ng-template>
      <mat-tab-group class="edit-input-half-field cartoes-tabs" (selectedIndexChange)="onTabIndexChange($event)">
        <mat-tab *ngFor="let cofx of listaControleFinancaXMovimentoCartoes">
          <ng-template mat-tab-label> {{cofx.noTipoMovimento}} {{cofx.vlSaldo ? ' - ' + formatBRL(cofx.vlSaldo) : ''}} </ng-template>
          <div class="cartoes-div">
            <mat-card class="movimento-card movimento-card--cartao">
              <div class="movimento-card__header">
                <div class="movimento-card__header-left">
                  <mat-icon class="movimento-card__icon">credit_card</mat-icon>
                  <span class="movimento-card__title">{{ cofx.noTipoMovimento }}</span>
                </div>
                <span class="movimento-card__badge" matTooltip="Quantidade de movimentos">
                  {{ getMovimentosCount(cofx.idControleFinancaXMovimento) }}
                </span>
              </div>
              <div class="movimento-card__body">
                <app-controle-financa-movimentos [controleFinancaXMovimento]="cofx"
                  [id]="cofx.idControleFinancaXMovimento" (isChanged)="onCalcularValorTotal()"
                  (isDeleted)="onExcluirCartao(cofx)"
                  (countChanged)="onMovimentosCountChanged(cofx.idControleFinancaXMovimento, $event)"></app-controle-financa-movimentos>
              </div>
            </mat-card>
          </div>
        </mat-tab>
      </mat-tab-group>

    </mat-tab>
  </mat-tab-group>

</div>
<div class="subscription" *ngIf="subscription">
  <div>
    <mat-spinner></mat-spinner>
    <p>Carregando...</p>
  </div>
</div>
